import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { UserService } from 'src/app/services/firebase/user.service';
import { environment } from 'src/environments/environment';
import { User } from '../interfaces/user.interface';
import { AuthRepository } from '../state/auth.repository';
import { AuthEventsService } from './events.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private baseUrl: string;

  constructor(
    private http: HttpClient,
    private authRepo: AuthRepository,
    private events: AuthEventsService,
    private userService: UserService,
  ) {
    this.baseUrl = environment.API_URL;
  }

  login(credentials: any): Promise<any> {


    return new Promise(async (resolve, reject) => {

      const snapshot = await this.userService.login(credentials.email, credentials.password);
      const doc = snapshot.docs.pop();

      const token = undefined;
      const user: Partial<User> = {
        id: doc.id,
        ...doc.data()
      }

      if (!user.start_at) {
        user.start_at = DateTime.now().toString()
        this.userService.update(<User>user);
      }

      this.authRepo.updateState({ token, user: <User>user })
      this.events.loggedIn.next({
        code: 'loggedin',
        message: 'Usuário logado com sucesso',
        data: { token, user }
      })

      resolve({ user })

    })

  }

  register(data: any): Observable<any> {
    return this.http.post(`${environment.API_URL}/register`, data).pipe(take(1));
  }

  forgot(email: string): Observable<any> {
    const callbackUrl = `${window.location.origin}/password/reset`
    return this.http.post(`${environment.API_URL}/forgot`, { email, callbackUrl }).pipe(take(1));
  }

  reset(token: string, data: any): Observable<any> {
    return this.http.put(`${environment.API_URL}/reset/${token}`, data).pipe(take(1));
  }

  user(): Observable<any> {
    return this.http.get(`${environment.API_URL}/user`);
  }

  logout() {
    this.http.post(`${environment.API_URL}/logout`, {}).pipe(take(1)).subscribe({
      next: () => console.log('logged out'),
      error: () => console.log('logged out error')
    })
    this.authRepo.reset()
  }
}


